<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('chatbots')"
      :columns="columns"
      :column_search="true"
      resource_url="/whatsapp/chatbot/datatables"
    >
      <template v-slot:buttons>
        <!-- <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/whatsapp/settings' })"
        >
          <span class="icon"><i class="fa fa-cogs"></i></span>
          <span>{{ $t("settings") }}</span>
        </button> -->
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <chatbot-modal ref="chatbot_modal" @success="refresh" />
    <!-- <detail-modal ref="detail_modal" /> -->
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
} from "@/utils";
import ChatbotModal from "../chatbot_modal/Index.vue";
// import DetailModal from "../detail_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "ChatbotsDatatable",
  components: {
    GenericTable,
    ChatbotModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return row.name || "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "55%",
        //   data: (row) => {
        //     // return truncate(JSON.stringify(row), { length: 65 });
        //     return `<pre>${JSON.stringify(row)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small has-text-warning",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.chatbot_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete chatbot?"),
                    v,
                    () => {
                      del("/whatsapp/chatbot", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.chatbot_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
